import { useMemo } from "react";
import { useMapLayer } from "../hooks/useMapLayer";
import MeasurementObject, {
    MeasurementSelectionOverlay,
} from "../objects/MeasurementObject";

import type { MapLayerProps, MeasurementMapObject } from "../types";

type MeasurementsLayerProps = MapLayerProps<MeasurementMapObject>;

const MeasurementsLayer = ({
    id,
    items,
    selectedIds,
    onItemClick,
    onItemHover,
    onItemLeave,
}: MeasurementsLayerProps) => {
    const { items: layerItems, selectedItems } = useMapLayer({
        items,
        selectedIds,
    });
    const baseObjects = useMemo(
        () =>
            layerItems.map((item) => (
                <MeasurementObject
                    key={item.id}
                    item={item}
                    layerId={id}
                    onItemClick={onItemClick}
                    onItemHover={onItemHover}
                    onItemLeave={onItemLeave}
                />
            )),
        [id, layerItems, onItemClick, onItemHover, onItemLeave],
    );

    return (
        <pixiContainer label="measurements-layer">
            {baseObjects}
            {selectedItems.map((item) => (
                <MeasurementSelectionOverlay key={item.id} item={item} />
            ))}
        </pixiContainer>
    );
};

export default MeasurementsLayer;
